exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-info[data-v-7cbb7409] {\n  width: 100%;\n  min-height: -moz-fit-content;\n  min-height: fit-content;\n}\niframe[data-v-7cbb7409] {\n  border: none;\n}\na[data-v-7cbb7409] {\n  text-decoration: underline;\n  -webkit-text-decoration-color: #080808;\n          text-decoration-color: #080808;\n}\n.subject-text[data-v-7cbb7409] {\n  width: auto;\n  word-break: break-word;\n  overflow: hidden;\n  padding-right: 16px;\n}\n.subject-text[data-v-7cbb7409]:first-letter {\n  text-transform: uppercase;\n}", ""]);

// exports
